module.exports = __webpack_public_path__ + "static/pic11-384ea9967e094d22f216c6c2720a9db0.jpg";